import {
  List,
  EditButton,
  SimpleList,
  Datagrid,
  DateField,
  ShowButton,
  TopToolbar,
  CreateButton,
  FunctionField,
} from "react-admin";
import { EmptyList } from "server/components";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import permissions from "app/permissions";
import { formatDateBg } from "../../../server/formatting/formatDateBg";
import NameBgField from "../components/Fileds/NameBgField";
import NameEnField from "../components/Fileds/NameEnField";
import SecuredComponent from "server/security/SecuredComponent";
import { MobileListRow } from "features/MobileListRow";

const ActivityField = ({ record }) => (
  <Typography
    fontSize={14}
    color={record?.isFinished ? "error" : theme => theme.palette.success.main}
  >
    {record?.isFinished ? "Приключена" : "Активна"}
  </Typography>
);

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const ListHospitalContractCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      actions={<ListActions />}
      title="Договори с болница"
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[{ label: "Начало на регистрация", value: formatDateBg(record.registrationStart) }]}
              />
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "Край на регистрация", value: formatDateBg(record.registrationEnd) }]} />
              <MobileListRow fields={[{ value: <ActivityField record={record} /> }]} />
            </div>
          )}
          tertiaryText={record => (
            <>
              <SecuredComponent permission={permissions.canUpdateCampaigns}>
                <EditButton
                  label=""
                  disabled={record?.isFinished}
                />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewCampaigns}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.compactDatagridCells}
        >
          <NameBgField label="Име на български език" />
          <NameEnField label="Име на английски език" />
          <DateField
            source="registrationStart"
            label="Начало на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />
          <DateField
            source="registrationEnd"
            label="Край на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />
          <FunctionField
            label="Активност"
            render={record => <ActivityField record={record} />}
          />
          {/* All row actions share one column; below xl they stack vertically. */}
          <FunctionField
            label="Действия"
            render={record => (
              <Box sx={settings.style.stackingActionButtons}>
                <SecuredComponent permission={permissions.canUpdateCampaigns}>
                  <EditButton disabled={record?.isFinished} />
                </SecuredComponent>
                <SecuredComponent permission={permissions.canPreviewCampaigns}>
                  <ShowButton />
                </SecuredComponent>
              </Box>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};
export default ListHospitalContractCampaigns;
